module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "pg17"
    }
  }, [_vm._v("4")])]), _c('a', {
    attrs: {
      "id": "pg17"
    }
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_vm._v("USS "), _c('i', [_vm._v("Huron")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The USS "), _c('i', [_vm._v("Huron")]), _vm._v(" was built in 1875 in Chester, Pennsylvania. Its length was 175 feet, the beam was 32 feet, and it boasted a compound steam engine with five coal-burning boilers, a 12-foot propeller and three masts with sails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Its armament consisted of one eleven-inch Dahlgren smoothbore cannon, two nine-inch Dahlgren smoothbore cannons, one sixty-pound Parrott rifle, one twelve-pound Dahlgren boat howitzer and one fifty-caliber Gatling gun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("USS "), _c('i', [_vm._v("Huron")]), _vm._v(" was a 120,000-ton Alert Class Screw Steam gunboat commissioned in November 1875 manned by 16 officers and 118 enlisted men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During its brief career, from 1875 to 1877, the USS "), _c('i', [_vm._v("Huron")]), _vm._v(" visited ports in Mexico, Venezuela and Colombia; Key West, Florida; Mobile, Alabama; Charleston, South Carolina; Norfolk, Virginia; Boston, Massachusetts; New York; and Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The USS "), _c('i', [_vm._v("Huron")]), _vm._v(" left Hampton Roads, Virginia, on Friday, November 23, 1877, headed for Havana, Cuba. On the first night at sea, it encountered a storm with strong winds blowing from the southeast. The storm winds, combined with a small error in the ship’s compass, caused the ship to run aground off Nags Head, North Carolina, at about 1:30 a.m. on November 24, 1877. The USS "), _c('i', [_vm._v("Huron")]), _vm._v(" struck ground two miles north of lifesaving station no. 7, which was not manned.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pg17"
    }
  }, [_vm._v("Grounded, the USS "), _c('i', [_vm._v("Huron")]), _vm._v(" was about two hundred yards from the beach. Due to the heavy surf, strong currents and cold temperature, most of the ")]), _c('a', {
    attrs: {
      "id": "pg18"
    }
  }, [_vm._v("crew were stranded on the ship waiting for help. No help ever came. Many of the crew were washed overboard by high waves. Ninety-eight men lost their lives during the night. The USS "), _c('i', [_vm._v("Huron")]), _vm._v(" was under the command of George P. Ravan.")])]), _c('a', {
    attrs: {
      "id": "pg18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The wrecking steamer "), _c('i', [_vm._v("Resolute")]), _vm._v(", the USS "), _c('i', [_vm._v("Swatara")]), _vm._v(" and the tug "), _c('i', [_vm._v("Fortune")]), _vm._v(" were sent to render assistance, but they were too late. Today, the USS "), _c('i', [_vm._v("Huron")]), _vm._v(" site is located about 250 yards from the beach. Buoys mark the bow and stern of the wreck during the summer months.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the 1870s. the ship’s cannons and much of the machinery were salvaged. Today, collecting artifacts from the wreck is strictly prohibited. The shipwrecks in North Carolina waters are protected by state and federal law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The USS "), _c('i', [_vm._v("Huron")]), _vm._v(" is listed in the National Register of Historic Places, and in 1991, the secretary of the North Carolina Department of Cultural Resources designated the site as North Carolina’s first Historical Shipwreck Preserve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('i', [_vm._v("Huron")]), _vm._v(" marker reads, “The wreck of the Huron near this spot.” On November 24, 1877, the USS "), _c('i', [_vm._v("Huron")]), _vm._v(" ran ashore, and ninety-eight lives were lost.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b180422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter04.vue
// module id = 84
// module chunks = 0